var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseWrapper',[_c('div',{staticClass:"space-y-6"},[_c('PromoActiveList'),_c('ShareLinkMemberList')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }